import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {useHistory} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import CartItem from './CartItem';
import FormattedPrice from '../../components/FormattedPrice';
import {clearOrder, setOrderDateTime, setOrderType} from '../../redux/actions/orderActions';
import IPosModal from '../../IPosModal';
import {DeliveryType} from '../../constants/deliveryTypes';
import {currentDeliveryItem, orderSubTotal, orderTotal} from '../../redux/selectors/order';
import {getLanguageById} from '../../helpers/language';
import OrderTypeSwitcher from './OrderTypeSwitcher';
import {setDeliveryType} from '../../redux/actions/baseActions';
import {clearClientInfo} from '../../redux/actions/clientActions';
import {setValueCardItem, valueCardGetBenefitsQuery, setValueCardBenefitsResponse} from '../../redux/actions/valueCardAction';
import { generateValueCardOrderItem } from "../../helpers/common";

const Cart = ({
                t,
                orderItems,
                clearOrder,
                menuItemTypes,
                branchInfo,
                editable = true,
                totalAmount,
                subtotalAmount,
                deliveryItem,
                currentLanguageId,
                currentUiLanguageId,
                orderType,
                setOrderType,
                setOrderDateTime,
                orderDateTime,
                currentDeliveryType,
                setDeliveryType,
                currentTableId,
                valuecardInfo,
                valuecardItem,
                clearClientInfo,
                setValueCardItem,
                valueCardGetBenefitsQuery,
                setValueCardBenefitsResponse
              }) => {
  const isEmpty = orderItems.length === 0;
  const history = useHistory();
  const currentLocale = getLanguageById(currentLanguageId);

  const minOrderAmountPresent = +branchInfo.MinDeliveryAmount > 0;
  const minOrderAmount = +branchInfo.MinDeliveryAmount;
  const allowToPay = currentDeliveryType === DeliveryType.DELIVERY ? !minOrderAmountPresent || (minOrderAmountPresent && subtotalAmount >= minOrderAmount) : true;

  const cartTotalQuantity = orderItems.reduce((acc, item) => {
    return acc + item.orderItem.quantity;
  }, 0);

  useEffect(() => {
    const el = document.getElementById('order-items-table');
    if (el) {
      el.scrollTo(0, el.scrollHeight);
    }

  }, [orderItems]);

  const onClearOrder = () => {
    IPosModal.confirmation({
      title: t('dialogs.clear_cart'),
      message: t('dialogs.clear_cart_are_you_sure'),
      okButtonText: t('buttons.delete'),
      cancelButtonText: t('buttons.cancel'),
      onOk: () => {
        clearOrder();
      }, onClose: () => {

      }
    });
  };

  const onPayClick = () => {
    if (editable) {
      if (allowToPay) {

        if (valuecardInfo)
        {
          onValueCardGetBenefitsQuery();
        }

        history.push(`/${branchInfo.branch_guid_code}/client`);

        document.getElementById('scrollable-items-container').scrollTo(0, 0);
      }
    } else {
      history.push(`/${branchInfo.branch_guid_code}/order`);
    }
  };

  const onValueCardGetBenefitsQuery = async () => {
    const res = await valueCardGetBenefitsQuery();
    if (!res || (res && (res.common.isError || res == ''))) {
      showAlert(res.common.message);
    }
    else
    {
      setValueCardBenefitsResponse(res);
      const discount = (res.discount * 100).toFixed(0);
      if (discount !== 0)
      {
        const valueCardOrderItem = generateValueCardOrderItem(res, valuecardInfo.memberCardNumber, branchInfo.valueCardMenuItem, menuItemTypes, discount);
        valueCardOrderItem.editAllowed = false;
        setValueCardItem(valueCardOrderItem);
      }
    }
  };

  const showAlert = (message) => {
    IPosModal.alert({
      title: t('add_item_modal.errors.title'),
      message: message,
      okButtonText: t('buttons.ok'),
      cancelButtonText: t('buttons.cancel'),
      onOk: () => {
      }
    });
  };

  const onChangeOrderDateTime = (dateTime) => {
    setOrderDateTime(dateTime);
  };

  const onSetDeliveryType = (deliveryType) => {
    if (deliveryType === DeliveryType.TA) {
      // Just to clear address data if defined
      clearClientInfo();
    }
    setDeliveryType(deliveryType);
  };

  if (orderItems.length === 0) {
    return (
      <div className="nav-side-menu cart">
        <h3 className="headline">
          <span>{t('cart.empty_cart_title')}</span>
          {editable && <div className={ 'clear-all-btn disabled' }>
            <FontAwesomeIcon icon="trash" />
          </div>
          }
        </h3>
        <div className={ 'empty_cart' }>
          <div className={ 'empty_cart_description' }>
            {t('cart.empty_cart_description')}
          </div>
          <div className={ 'empty_cart_icon' }>
            <FontAwesomeIcon icon="shopping-cart" />
          </div>
        </div>
        <div className="wc-proceed-to-checkout">
          <a href="#" className="btn btn-primary checkout-button btn alt wc-forward disabled">
            {t('cart.checkout')}
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="nav-side-menu cart">
      <h3 className="headline">
        <span>{t('cart.title')}</span>
        {editable && (
          <div className={ 'clear-all-btn' } onClick={ onClearOrder }>
            <FontAwesomeIcon icon="trash" />
          </div>
        )}

      </h3>

      {!isEmpty &&
        <>
        <div className="cart-collaterals">
          <div className="cart_totals">
            <div className="table-responsive" id={ 'order-items-table' }>
              <table cellSpacing="0" className="table">
                <tbody>
                <tr>
                  {/* {valuecardItem && (
                    <td colSpan={ 3 }>
                      {
                        <CartItem
                          cartItem={ valuecardItem }
                          editable={ false }
                      />
                      }
                    </td>
                  )}                   */}
                  <td colSpan={ 3 }>
                    {
                      <div>
                      {valuecardItem && (                       
                            <CartItem
                              cartItem={ valuecardItem }
                              editable={ false }
                          />)
                      }
                      
                      {orderItems.map((item, index) => (
                        <CartItem
                          key={ item.menuItem.menu_item_id + index }
                          cartItem={ item }
                          editable={ editable }
                        />
                      ))}
                      </div>
                    }
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
            <div className="cart-footer">
                <table cellSpacing="0" className="table subtotal">
                    <tbody>
                    <tr className="cart-subtotal">

                        <th>{t('cart.subtotal')} ({cartTotalQuantity})</th>
                        <td className={ 'text-right' }><span className="amount">
                      <FormattedPrice price={ subtotalAmount } />
                    </span></td>
                    </tr>
                    {
                        deliveryItem && (
                            <tr>
                                <td colSpan={ 3 }>
                                    <CartItem
                                        key={ deliveryItem.menuItem.menu_item_id }
                                        cartItem={ deliveryItem }
                                        editable={ false }
                                    />
                                </td>
                            </tr>
                        )
                    }
                    </tbody>
                </table>
                {/* {branchInfo.ShowTakeAway && branchInfo.ShowDelivery && (!currentTableId && currentDeliveryType !== DeliveryType.EAT_IN) && (
                    <CartDeliveryTypeSwitcher
                        t={ t }
                        editable={ editable }
                        currentDeliveryType={ currentDeliveryType }
                        setDeliveryType={ onSetDeliveryType }
                    />
                )} */}

                {!currentTableId && currentDeliveryType !== DeliveryType.EAT_IN && (
                    <OrderTypeSwitcher
                        locale={ currentLocale }
                        t={ t }
                        orderType={ orderType }
                        setOrderType={ setOrderType }
                        setOrderDate={ onChangeOrderDateTime }
                        orderDateTime={ orderDateTime }
                        editable={ editable }
                        branchInfo={branchInfo}
                        currentUiLanguageId={currentUiLanguageId}
                    />
                )}

                <div className="wc-proceed-to-checkout">
                    {!allowToPay && (
                        <div className={ 'minimum-order-amount-warning' }>
                            <div>{t('cart.min_order_amount_warning', {minOrderAmount: `${(Number(minOrderAmount) / 100).toFixed(2)} ₪`})}</div>
                        </div>
                    )}

                    {allowToPay && (
                        <div onClick={ onPayClick } className={ 'checkout-button' }>
                            {editable && allowToPay && (
                                <>
                                    <div>{t('cart.to_pay')}</div>
                                    <div><FormattedPrice price={ totalAmount } /></div>
                                </>
                            )}
                            {!editable && (
                                <>
                                    <div>{t('cart.update_order')}</div>
                                </>
                            )}
                        </div>
                    )}

                    {/*<a href="#" className="btn btn-primary checkout-button btn alt wc-forward">*/}

                    {/*</a>*/}
                </div>
            </div>
        </>
      }

    </div>
  );
};

const mapStateToProps = (state) => {
    const {
        orderItems,
        branchInfo,
        menuItemTypes,
        currentLanguageId,
        currentUiLanguageId,
        orderType,
        orderDateTime,
        currentDeliveryType,
        currentTableId,
        valuecardInfo,
        valuecardItem
    } = state;

    return {
        orderItems,
        branchInfo,
        menuItemTypes,
        currentLanguageId,
        currentUiLanguageId,
        orderType,
        orderDateTime,
        currentDeliveryType,
        currentTableId,
        valuecardInfo,
        valuecardItem,
        totalAmount: orderTotal(state),
        subtotalAmount: orderSubTotal(state),
        deliveryItem: currentDeliveryItem(state)
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            clearOrder,
            setOrderType,
            setOrderDateTime,
            setDeliveryType,
            clearClientInfo,
            setValueCardItem,
            valueCardGetBenefitsQuery,
            setValueCardBenefitsResponse
        },
        dispatch,
    );

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Cart));
